type OptionalProps = {
  /**
   * show Whether or not to render the children component(s)
   */
  readonly show?: boolean;
  /**
   * children The children component(s)
   **/
  readonly children: React.ReactNode;
};

/**
 * Either renders or omits the provided children component(s) from the DOM depending
 * on a condition.
 */
export const Optional: React.FunctionComponent<OptionalProps> = ({
  show,
  children,
}) => <>{show === true ? children : undefined}</>;
